import React, { PureComponent } from 'react';

import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import { checkAvatarDimension, remCss, scssVariables } from 'src/helpers';
import { popupModel } from './index';
import UploadProgress from '../basic/UploadProgress';

const loadImg = (file) => {
  if (file.uri) return file.uri;
  return URL.createObjectURL(file);
};
export class ThumbnailUploader extends PureComponent {
  constructor(props) {
    super(props);
    this.fileRef = React.createRef();
  }
  onChangeFile = async (event) => {
    const file = event.target.files.length > 0 ? event.target.files[0] : null;
    const { setImage, type } = this.props;
    if (!file) return setImage(null);
    const fileType = file['type'];

    if (!fileType.includes('image/')) return;

    if (!(await checkAvatarDimension(file))) return;

    if (file)
      popupModel.openCropImage({
        src: file,
        isCircle: type === 'round',
        onSave: (file) => {
          setImage(file);
        }
      });
    else setImage(null);

    event.target.value = null;
  };

  render() {
    let {
      type = 'square',
      image,
      style = {},
      setImage,
      activeCloseBtn = true,
      disabled = false
    } = this.props;
    const mainStyles = { ...style, cursor: 'pointer' };
    mainStyles.height = remCss(style.height || 100);
    mainStyles.width = remCss(style.width || 100);
    image =
      image && image !== ''
        ? typeof image === 'string'
          ? { uri: image, type: 'image' }
          : image
        : '';

    let uploadState = image?.uploadState || {};

    return (
      <div
        className={'mc-thumbnail-up ' + (image ? 'has-image ' : '') + 'type-' + type}
        style={mainStyles}
        onClick={() => !disabled && this.fileRef.current.click()}
      >
        {image ? (
          <>
            <img src={loadImg(image)} alt='' />
            {uploadState.status && (
              <UploadProgress
                {...uploadState}
                file={image}
                small={false}
                engine={false}
                showBytes={false}
                wrapperStyle={{ top: 0 }}
              />
            )}
          </>
        ) : (
          <SVGIcon iconname={'photo-camera-icon'} />
        )}
        <div className={'mc-thumbnail-up-btn-group'}>
          <button className={'mc-thumbnail-up-btn'} type='button'>
            <SVGIcon
              width={24}
              padding={5}
              circle
              iconname={BASE_ICONS.DOWNLOAD}
              fill={scssVariables['colors-mc-text-light']}
            />
          </button>
          {activeCloseBtn && (
            <button
              className={'mc-thumbnail-up-btn'}
              type='button'
              onClick={() => !disabled && setImage(null)}
            >
              <SVGIcon
                iconname={BASE_ICONS.CLOSE}
                width={24}
                circle
                dark
                padding={5}
                fill={scssVariables['colors-mc-primary']}
              />
            </button>
          )}
        </div>
        <input
          hidden
          type={'file'}
          onChange={this.onChangeFile}
          ref={this.fileRef}
          accept='image/*'
        />
      </div>
    );
  }
}
